import './FormActionRedirection.css';
import TextInput from '/src/components/UI/TextField/TextInput';
import VariableDropdown from '../../Variables/VariablesDropdown/VariablesDropdown';
import Button from '/src/components/UI/Button/Button';
import RedirectionBlock from './RedirectionBlock/RedirectionBlock';
import AreaList from '../UI/AreaList/AreaList';
import AreaListData from '../UI/AreaListData/AreaListData';
import TitleBlock from '../TitleBlock/TitleBlock';
import { useForm } from 'react-hook-form';
import editorAction from '../../../actions/editorAction';
import { useState, useEffect } from 'react';
import generateObjectId from '../../../utils/generateObjectId';
import { useTreeDispatchContext } from '../../../contexts/TreeContext';
import { useTreeStateContext } from '../../../contexts/TreeContext';
import binarySearchString from '../../../utils/binarySearchString';
import { BlockActionRedirectionDefault } from '../../../data/constant/blocks/BlockActionRedirectionDefault';
import NiceModal from '@ebay/nice-modal-react';
import ImportModalJson from "./modal/ImportModalJson"

function FormActionRedirection({id}) {

    const { children, blocks } = useTreeStateContext();
    const indexBlock = binarySearchString(blocks, id, 'object_id');
    const block = blocks[indexBlock] ?  blocks[indexBlock] : BlockActionRedirectionDefault
    const data = block.data
    const name = block.name
    var { redirections , variable, variable_redirect } = data;

    var childrenBlocks = children.filter(child => child.parent_block_id == id).sort((a, b) => a.index - b.index)

    const dispatch = useTreeDispatchContext();
    
    const { updateBlockData, createBlockChild, updateBlockChild, updateBlockChildren, deleteBlockChild } = editorAction();

    redirections = redirections.map( redirection => {
        const child = Object.values(childrenBlocks).filter( child => child.text == redirection.name && child.index != 0).pop();
        return {...redirection, child}
    }).filter(redirection => redirection.child);
    
    redirections = Object.values(redirections).sort((a, b) => a.child.index - b.child.index)
    

    const setValueForm = (index, name, value) => {
        if(name == 'name') {
            const object_id = redirections[index].child.object_id;
            dispatch({type : 'updateBlockChild', payload : { block_id : id, object_id, data : { text : value }}})
            updateBlockChild(id, object_id, { text : value })
        }

        setValue(`redirections.${index}.${name}`, value);
        dispatch({type : 'updateBlockData', payload : { id, data : { redirections : getValues().redirections }}})
        //dispatch({type : 'updateBlockData', payload : { id, data }})
        onSubmit(getValues());
    }

    
    const setValueDropdown = (name, value,_onSubmit = true) => {
        setValue(`${name}`, value);
        if (_onSubmit) {
            onSubmit(getValues());
        }
    }
    
    const lastChild = childrenBlocks[childrenBlocks.length - 1];

    const addNewRedirection = async(scroll, name = "", index = "", keywords ="", forbidden = '') => {

        const length = redirections.length + 1;

        const child = {
            text: name !== "" ? name : "Redirection " + length,
            object_id: generateObjectId(index !== "" ? index : length),
            index: index !== "" ? index : length,
            parent_block_id: lastChild.parent_block_id
        };

        const redirection = {
            name: name !== "" ? name : "Redirection " + length,
            keywords: keywords !== "" ? keywords : "",
            forbidden: forbidden !== "" ? forbidden : "",
            child
        };
        dispatch({type : 'createBlockChildBeforeLast', payload : { block_id : id, data : child}})

        createBlockChild(id, child)
        updateBlockChild(id, lastChild.object_id, { index : length + 1})

        dispatch({type : 'updateBlockData', payload : { id, data : { redirections : [...redirections, redirection] }}})
        redirections = [...redirections, redirection];
        setValue(`redirections.${length - 1}`, redirection)
        let dataToSend = getValues();
        dataToSend.redirections = redirections;
        onSubmit(dataToSend);
        if (scroll) scroll()
    }
 
    const addMultipleRedirections = async (importedRedirections = []) => {
        console.log(importedRedirections);
        for (let idx = 0; idx < importedRedirections.length; idx++) {
            const r = importedRedirections[idx];
            
            const created = await addNewRedirection(null,r.name, r.child?.index, r.keywords, r.forbidden);
        }
        //onSubmit(redirs);
    };

    const moveRedirection = (child, indexDestination) => {       
        [childrenBlocks[child.index], childrenBlocks[indexDestination]] = [childrenBlocks[indexDestination], childrenBlocks[child.index]] // swapping element
        childrenBlocks = childrenBlocks.map((childBlock,idx) => { return {...childBlock, index : idx }});

        [redirections[child.index - 1], redirections[indexDestination - 1]] = [redirections[indexDestination - 1], redirections[child.index - 1]] // swapping element
        redirections = redirections.map((redirection,idx) => { return {...redirection, child : {...redirection.child, index : idx + 1} }});
        dispatch({type : 'updateBlockData', payload : { id, data : { redirections : [...redirections] }}})
        setValue(`redirections`, [...redirections])

        const childrenBlocksServer = [childrenBlocks[child.index], childrenBlocks[indexDestination]];
        dispatch({type : 'updateBlockChildren', payload : { block_id : id, children : childrenBlocks}})
        //console.log(childrenBlocksServer);
        updateBlockChildren(id, childrenBlocksServer);
    }

    const deleteRedirection = async (child) => {

        const { index, object_id } = child
        
        var dataRedirections = getValues('redirections');
        dataRedirections = Object.values(dataRedirections)
                                 .filter(redirection => redirection.child.index  !== index )
                                 .map((redirection,idx) => { 
                                    return {...redirection, index : (idx + 1).toString()}
                                 });

        let newChildren = childrenBlocks
                      .filter(childBlock => childBlock.index != index && childBlock.index != 0)
                      .map((childBlock,idx) => { 
                        return {...childBlock, index : (idx + 1).toString()}
                      });
        
        dispatch({type : 'deleteBlockChildAndOrderOther', payload : { block_id : id, object_id }})

        deleteBlockChild(id, object_id)
        updateBlockChildren(id, newChildren);
        
        setValue('redirections', dataRedirections); // Update state form
        dispatch({type : 'updateBlockData', payload : { id, data : { redirections : redirections.filter(redirection => redirection.child.index !== index ) }}})
        onSubmit(getValues());
    }

    const functionRedirection = {
        setValue : setValueForm,
        deleteValue : deleteRedirection,
        move : moveRedirection
    }

    const { formState: { errors }, formState, getValues, setValue,watch } = useForm({
		mode: "onBlur",
		defaultValues: { 
            redirections, 
            variable : variable,
            variable_redirect : variable_redirect 
        }
	});

    const transformBlockName = (data) => {
        if(data.variable == null || (BlockActionRedirectionDefault.name != name && /^Redirection on \[/.test(name) == false) ) return data
        data.name = `Redirection on [${data.variable.name.toUpperCase()}]`
        return data
    }

    const exportBlock = () => {
        if (data.redirections.length <= 0) {
            console.log("No redirections to export");
            return;
        }
        const exportData = {
            variable: data.variable,
            variable_redirect: data.variable_redirect,
            redirections: redirections
        };

        const json = JSON.stringify(exportData, null, 2);

        // dl le json
        const blob = new Blob([json], { type: "application/json" });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "redirections.json";
        a.click();
    };
    const importBlock = () => {
        if (redirections.length > 0) {
            console.log("Can not import data because there is already some data into the block");
            return;
        }
    
        NiceModal.show(ImportModalJson, { nameDataset: name })
            .then(async (data) => {
                if (!data.redirections || data.redirections.length === 0) return;
                await addMultipleRedirections(data.redirections);
                /* marche pas avec le add redirections
                if (data.variable) {
                    setValueDropdown("variable",data.variable, false)
                }
                
                if (data.variable_redirect) { 
                    setValueDropdown("variable",data.variable_redirect, false)
                }
                    */
            });
    }

    const onSubmit = (data) => {
        data = transformBlockName(data);
        data.redirections = data.redirections
        .map(redirection => { return { name : redirection.name, keywords : redirection.keywords, forbidden : redirection.forbidden }}).filter(redirection => redirection);
        
        // Form to send to the server, the block state properties in the tree are diff
        const dataServer = {
            redirections : data.redirections,
            keyword_var : data.variable ? data.variable.name : null,
            keyword_redirect_var : data.variable_redirect ? data.variable_redirect.name : null
        }

        if(data.name) {
            dataServer.name = data.name
        }

        updateBlockData(id, data, dataServer)
    }

    return (
        <>
            <TitleBlock title="Redirection" titleInput="Redirection name" name={name} id={id} />
            {redirections.length <= 0 && <i className="fas fa-download icon_import" style={{ cursor: "pointer" }} aria-hidden="true" onClick={() => importBlock()} />}
            <i className="fas fa-upload icon_export" style={{ cursor: "pointer" }} aria-hidden="true" onClick={() => exportBlock()} />

            <div className='area-edit'>
                <div className='grid-row'>
                    <label className="dropdown_title"> From : </label>
                    <div className='dropdown_container'>
                        <VariableDropdown variable={watch("variable")} name='variable' setValue={setValueDropdown} />
                    </div>
                </div>
                <div className='grid-row'>
                    <label className="dropdown_title">Save result in : </label>
                    <div className='dropdown_container'>
                        <VariableDropdown variable={variable_redirect} name='variable_redirect' setValue={setValueDropdown} />
                    </div>
                </div>
                <AreaList title="Redirections" maxHeight="430px" buttonLabel="Add a Redirection" onClickButton={(arg) => addNewRedirection(...arg)}>
                    <AreaListData data={redirections} ComponentRow={RedirectionBlock} FunctionsRow={functionRedirection} componentKey="child.object_id"></AreaListData>
                </AreaList>
            </div>
        </>
    )
}

export default FormActionRedirection;